// Die festen Sätze, mit denen sich Spieler unterhalten (docs/architektur-paket-2.md, Abschnitt
// „Protokoll v2“). Es gibt keinen freien Text: Der Client schickt nur die Nummer eines Satzes,
// den Text setzt der Server ein. So kann im Spiel nichts geschrieben stehen, was niemand gewollt
// hat, und die Nachricht bleibt winzig.

/** Die auswählbaren Sätze in fester Reihenfolge; die Nummer im Protokoll ist der Index. */
export const PHRASES = ['Hallo!', 'Schau mal!', 'Ja', 'Nein', 'Danke', 'Tschüss!'] as const;

/** Gültige Satznummer: 0 bis `PHRASES.length - 1`. */
export type PhraseIndex = 0 | 1 | 2 | 3 | 4 | 5;

/** Prüft eine Satznummer aus einer Nachricht. */
export function isPhraseIndex(wert: unknown): wert is PhraseIndex {
  return typeof wert === 'number' && Number.isInteger(wert) && wert >= 0 && wert < PHRASES.length;
}

/** Der Satz zu einer Nummer. */
export function phraseText(index: PhraseIndex): string {
  return PHRASES[index];
}
